/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './shared/routes/__root'
import { Route as ProjectsRouteImport } from './shared/routes/projects'
import { Route as IndexRouteImport } from './shared/routes/index'
import { Route as ProjectsDevinoRouteImport } from './shared/routes/projects/devino'

const ProjectsRoute = ProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsDevinoRoute = ProjectsDevinoRouteImport.update({
  id: '/devino',
  path: '/devino',
  getParentRoute: () => ProjectsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/projects': typeof ProjectsRouteWithChildren
  '/projects/devino': typeof ProjectsDevinoRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/projects': typeof ProjectsRouteWithChildren
  '/projects/devino': typeof ProjectsDevinoRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/projects': typeof ProjectsRouteWithChildren
  '/projects/devino': typeof ProjectsDevinoRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/projects' | '/projects/devino'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/projects' | '/projects/devino'
  id: '__root__' | '/' | '/projects' | '/projects/devino'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ProjectsRoute: typeof ProjectsRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/projects': {
      id: '/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof ProjectsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/devino': {
      id: '/projects/devino'
      path: '/devino'
      fullPath: '/projects/devino'
      preLoaderRoute: typeof ProjectsDevinoRouteImport
      parentRoute: typeof ProjectsRoute
    }
  }
}

interface ProjectsRouteChildren {
  ProjectsDevinoRoute: typeof ProjectsDevinoRoute
}

const ProjectsRouteChildren: ProjectsRouteChildren = {
  ProjectsDevinoRoute: ProjectsDevinoRoute,
}

const ProjectsRouteWithChildren = ProjectsRoute._addFileChildren(
  ProjectsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ProjectsRoute: ProjectsRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
